import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import * as yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import PrimaryButton from '../ui/buttons/primaryButton';
import { updateGame } from '../../features/game/gameSlice';
import Input from '../ui/forms/fields/input';
import GreenSelector from '../ui/clubControls/greenSelector';
import Checkbox from '../ui/forms/fields/checkbox';

const schema = yup.object().shape({
  name: yup.string().required('Please enter game name'),
  rink: yup.number(),
  green: yup.string(),
  live: yup.boolean(),
  featured: yup.boolean(),
  venue: yup.string().required('Please select a venue.')
});

const EditGame = ({ game, open, onClose }) => {
  const dispatch = useDispatch();
  const event = useSelector((state) => state.event?.event);
  const eventSections = useSelector((state) => state.event?.event?.sections);

  // const {
  //   register,
  //   handleSubmit,
  //   reset,
  //   setValue,
  //   formState: { errors }
  // } = useForm({
  //   resolver: yupResolver(schema)
  // });
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: game?.name || '',
      venue: game?.venue?.id || game?.venue || '',
      green: game?.green || '',
      rink: game?.rink || '',
      live: game?.live || false,
      featured: game?.featured || false
    }
  });

  const { errors } = methods.formState;

  useEffect(() => {
    if (!game) return;

    let gameName = game.name;

    if (game.name === undefined || game.name === 'undefined') {
      try {
        const gameSection = eventSections.find((section) => section.id === game.section);
        const sectionGameIndex = gameSection.games.findIndex(
          (sectionGame) =>
            game.teams.teamA.id === sectionGame.teamA && sectionGame.teamB === game.teams.teamB.id
        );

        if (sectionGameIndex > -1) {
          gameName = gameSection.name + ' Game ' + (sectionGameIndex + 1);
        } else {
          gameName = '';
        }
      } catch (error) {
        gameName = '';
      }
    }

    methods.reset({
      name: gameName || '',
      venue: game?.venue?.id || game?.venue || '',
      green: game?.green || '',
      rink: game?.rink || '',
      live: game?.live || false,
      featured: game?.featured || false
    });
  }, [game, eventSections, methods]);

  const saveGame = (data) => {
    dispatch(updateGame({ ...data, id: game.id }));
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Game</DialogTitle>
      <DialogContent>
        <FormProvider {...methods}>
          <Input label="Game Name" {...methods.register('name')} />
          <GreenSelector event={event} game={game} />
          <Checkbox
            name={'live'}
            label="Game is streamed Live."
            control={methods.control}
            error={errors.live}
          />
          <br />
          <Checkbox
            name={'featured'}
            label="Game is featured."
            control={methods.control}
            error={errors.featured}
          />
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <PrimaryButton onClick={() => methods.handleSubmit(saveGame)()}>Save</PrimaryButton>
        <PrimaryButton onClick={() => onClose()}>Cancel</PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditGame;
